module.exports = __webpack_public_path__ + "img/book-circle-arrow-up.5cfa7d58.svg";